export default "__VITE_ASSET__BiQIGpcX__"